<template>
    <DsModalDialog
        v-model="modelValue"
        :css-class="[
            'bonusomat-raffle-table',
            pickerActiveTab == RafflePrizesPickerItem.LosovackaBonusomat ? 'bonusomat-raffle-table--bonusomat' : '',
        ]"
        theme="dark"
        @update:model-value="closeModal"
    >
        <template #top>
            <DsSegmentedPicker
                v-if="defaultDrawWinTable && allwynDraw"
                class="ft-detail-body__picker"
                theme="dark"
                size="lg"
                v-model="pickerActiveTab"
            >
                <DsSegmentedPickerItem
                    :title="RafflePrizesPickerItem.LosovackaBonusomat"
                    :name="RafflePrizesPickerItem.LosovackaBonusomat"
                ></DsSegmentedPickerItem>
                <DsSegmentedPickerItem
                    :title="RafflePrizesPickerItem.LosovackaAllwyn"
                    :name="RafflePrizesPickerItem.LosovackaAllwyn"
                ></DsSegmentedPickerItem>
            </DsSegmentedPicker>

            <template v-if="pickerActiveTab == RafflePrizesPickerItem.LosovackaBonusomat">
                <DsTopSlotHeadlineSubheadline :headline="defaultDrawWinTable?.title" :display-headline-as-html="true" />
                <p class="bonusomat-raffle-table__description" v-html="defaultDrawWinTable?.description"></p>
            </template>
            <template v-else-if="pickerActiveTab == RafflePrizesPickerItem.LosovackaAllwyn">
                <DsTopSlotHeadlineSubheadline
                    :headline="allwynDraw?.winTable?.title"
                    :display-headline-as-html="true"
                />
                <p class="bonusomat-raffle-table__description" v-html="allwynDraw?.winTable?.description"></p>
            </template>
        </template>
        <template #content>
            <div
                class="bonusomat-raffle-table__cols"
                v-show="pickerActiveTab == RafflePrizesPickerItem.LosovackaBonusomat"
            >
                <div class="bonusomat-raffle-table__image-section">
                    <div class="bonusomat-raffle-table__image-wrap">
                        <WebpImage
                            :src="bonImgUrl('raffle/zombies-with-ticket', 'png')"
                            alt="Pán Zelený s Pánem Červeným stojící vedle barelu toxické tekutiny"
                            css-class="bonusomat-raffle-table__image"
                        />
                    </div>
                    <p class="bonusomat-raffle-table__description" v-html="defaultDrawWinTable?.mainText"></p>
                </div>
                <div class="bonusomat-raffle-table__table-section">
                    <h3 class="bonusomat-raffle-table__label">Co můžete vyhrát?</h3>
                    <DsTable theme="dark">
                        <DsRow>
                            <DsCell type="th">Pořadí</DsCell>
                            <DsCell type="th">Cena</DsCell>
                        </DsRow>
                        <DsRow v-for="(item, index) in defaultDrawWinTable?.prizes" :key="index">
                            <DsCell>
                                <WebpImage
                                    v-if="index === 0"
                                    :src="bonImgUrl('raffle/medal-1st', 'svg')"
                                    alt="Zlatá medaile"
                                    css-class="bonusomat-raffle-table__table-img--medal"
                                />
                                <WebpImage
                                    v-else-if="index === 1"
                                    :src="bonImgUrl('raffle/medal-2nd', 'svg')"
                                    alt="Stříbrná medaile"
                                    css-class="bonusomat-raffle-table__table-img--medal"
                                />
                                <WebpImage
                                    v-else-if="index === 2"
                                    :src="bonImgUrl('raffle/medal-3rd', 'svg')"
                                    alt="Bronzová medaile"
                                    css-class="bonusomat-raffle-table__table-img--medal"
                                />
                                <span v-else>{{ index + 1 }}.</span>
                            </DsCell>
                            <DsCell>{{ item }}</DsCell>
                        </DsRow>
                    </DsTable>
                </div>
            </div>
            <div
                class="bonusomat-raffle-table__allwyn"
                v-show="pickerActiveTab == RafflePrizesPickerItem.LosovackaAllwyn"
            >
                <WebpImage
                    v-show="allwynDraw?.winTable?.imageLogo"
                    css-class="bonusomat-raffle-table__allwyn-logo"
                    :src="allwynDraw?.winTable?.imageLogo"
                    alt="Zážitek - logo"
                    :loading-priority="'high'"
                />
                <WebpImage
                    v-show="allwynDraw?.winTable?.image"
                    css-class="bonusomat-raffle-table__allwyn-image"
                    :src="allwynDraw?.winTable?.image"
                    alt="Zážitek - obrázek"
                    :loading-priority="'high'"
                />
                <p class="bonusomat-raffle-table__description" v-html="allwynDraw?.winTable?.mainText"></p>
            </div>
        </template>
        <template #bottom>
            <DsBottomSlotActionBar
                :has-btn-close="false"
                :has-btn-submit="!showLoginBtn && !showAllwynBtn"
                :button-submit-icon="btnRightIcon && { iconRight: btnRightIcon }"
                theme="dark"
                size="sm"
                :btn-submit-text="btnSubmitText ?? 'Rozumím'"
                @submit-dialog="submitDialog"
            >
                <template v-if="showLoginBtn || showAllwynBtn" #additional>
                    <DsButton
                        v-if="showAllwynBtn"
                        :href="allwynInformationPageUrl"
                        eventName="openLinkBrowser"
                        :event-argument="allwynInformationPageUrl"
                        :openInNewTab="true"
                        type="primary"
                        icon-right="arrow-right"
                        theme="dark"
                        size="sm"
                    >
                        Joker výhody
                    </DsButton>
                    <MobileAppLink
                        v-else-if="showLoginBtn"
                        href="javascript:ng_fw.showLogin();"
                        event-name="goToDeepLink"
                        event-argument="sazkahry://home/login"
                        class="button button--primary button--dark button--sm"
                        @link-clicked="submitDialog"
                    >
                        Přihlásit se
                    </MobileAppLink>
                </template>
            </DsBottomSlotActionBar>
        </template>
    </DsModalDialog>
</template>

<script lang="ts" setup>
import { ref, watch, computed } from "vue";
import DsBottomSlotActionBar from "@sazka/design-system/src/bottom-slot/ds-bottom-slot-action-bar.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import DsSegmentedPicker from "@sazka/design-system/src/segmented-picker/ds-segmented-picker.vue";
import DsSegmentedPickerItem from "@sazka/design-system/src/segmented-picker-item/ds-segmented-picker-item.vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsTopSlotHeadlineSubheadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import MobileAppLink from "@sazka/mobile-apps/components/mobile-app-link.vue";
import { SvgIcons } from "@sazka/design-system/src/icon/types";
import { BonusomatAllwynDraw } from "../../models/bonusomat-draw";
import { BonusomatDefaultDrawWinTable } from "../../models/draw-win-table";
import { bonImgUrl } from "../../utils/image-src";

const modelValue = defineModel<boolean>({ required: true });

const props = defineProps<{
    defaultDrawWinTable?: BonusomatDefaultDrawWinTable;
    allwynDraw?: BonusomatAllwynDraw;
    btnSubmitText?: string;
    btnRightIcon?: SvgIcons;
    showLoginBtn?: boolean;
}>();

const emit = defineEmits(["submitDialog"]);
const allwynInformationPageUrl = appSettings["AllwynJokerPageUrl"];

enum RafflePrizesPickerItem {
    LosovackaBonusomat = "Losovačka Bonusomat",
    LosovackaAllwyn = "Losovačka Allwyn",
}
const pickerActiveTab = ref(
    props.allwynDraw && !props.defaultDrawWinTable
        ? RafflePrizesPickerItem.LosovackaAllwyn
        : RafflePrizesPickerItem.LosovackaBonusomat
);

const showAllwynBtn = computed(() => pickerActiveTab.value == RafflePrizesPickerItem.LosovackaAllwyn);

const closeModal = () => {
    modelValue.value = false;
};

const submitDialog = () => {
    emit("submitDialog", null);
    closeModal();
};

const preselectAppropriateTab = () => {
    if (
        !props.defaultDrawWinTable &&
        props.allwynDraw &&
        pickerActiveTab.value == RafflePrizesPickerItem.LosovackaBonusomat
    ) {
        pickerActiveTab.value = RafflePrizesPickerItem.LosovackaAllwyn;
    } else if (pickerActiveTab.value != RafflePrizesPickerItem.LosovackaBonusomat) {
        pickerActiveTab.value = RafflePrizesPickerItem.LosovackaBonusomat;
    }
};

watch(
    () => props.defaultDrawWinTable,
    (newDefaultDrawWinTable) => {
        if (!newDefaultDrawWinTable) {
            if (props.allwynDraw) {
                pickerActiveTab.value = RafflePrizesPickerItem.LosovackaAllwyn;
            } else {
                closeModal();
            }
        }
    }
);

watch(
    () => props.allwynDraw,
    (newAllwynDraw) => {
        if (!newAllwynDraw) {
            if (props.defaultDrawWinTable) {
                pickerActiveTab.value = RafflePrizesPickerItem.LosovackaBonusomat;
            } else {
                closeModal();
            }
        }
    }
);

watch(
    modelValue,
    () => {
        preselectAppropriateTab();
    },
    {
        immediate: true,
    }
);
</script>
